import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RiskScoreItem } from '../../../types';
import { individualClientsRiskApi } from '../services';

export interface IndividualClientsSourceOfFundsFormState {
  itemId?: string;
  item?: RiskScoreItem;
}

const initialState: IndividualClientsSourceOfFundsFormState = {};

export const individualClientsSourceOfFundsFormSlice = createSlice({
  name: 'individualClientsSourceOfFundsForm',
  initialState,
  reducers: {
    clearSourceOfFundsFormState: (state) => {
      state.itemId = undefined;
      state.item = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      individualClientsRiskApi.endpoints.getSourceOfFunds.matchFulfilled,
      (state, action: PayloadAction<{ data: RiskScoreItem }>) => {
        state.item = action.payload.data;
        state.itemId = action.payload.data.id;
      },
    );
  },
});

export const { clearSourceOfFundsFormState } =
  individualClientsSourceOfFundsFormSlice.actions;

export default individualClientsSourceOfFundsFormSlice.reducer;
